import type { I18nInstance } from '@affine/i18n';

export const MAIL_APP_LABEL_I18N_KEY =
  'com.streamlain.rootAppSidebar.email' as const;

export function getMailAppLabel(i18n: I18nInstance): string {
  return i18n[MAIL_APP_LABEL_I18N_KEY]();
}
